import React from "react";
import { Link } from "react-router-dom";

const PaymentFailed = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-red-50 px-4">
      <div className="bg-white rounded-xl shadow-lg p-8 max-w-md text-center">
        <div className="text-5xl mb-4">  <span role="img" aria-label="payment failed">❌</span></div>

        <h1 className="text-2xl font-bold text-red-700 mb-2">
          Payment Failed
        </h1>

        <p className="text-gray-600 mb-6">
          Something went wrong with your payment. Please try again.
        </p>

        <div className="flex flex-col gap-3">
          <Link
            to="/checkout"
            className="bg-red-600 text-white py-2 rounded-lg hover:bg-red-700 transition"
          >
            Retry Payment
          </Link>

          <Link
            to="/cart"
            className="border border-red-600 text-red-600 py-2 rounded-lg hover:bg-red-50 transition"
          >
            Go to Cart
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailed;
